<template>
  <div class="challenge">
    <TheTitle></TheTitle>
    <FiltersResults></FiltersResults>
    <RaidResults v-if="$store.state.current_epreuve == 'raid'"></RaidResults>
    <EpreuveResults v-else></EpreuveResults>



  </div>
</template>

<script>
import RaidResults from "@/components/Resultats/RaidResults.vue";
import EpreuveResults from "@/components/Resultats/EpreuveResults.vue";
import FiltersResults from "@/components/Resultats/FiltersResults.vue";
import TheTitle from "@/components/App/TheTitle.vue";
export default {
  name: "ChallengeView",
  components: {
    RaidResults,
    FiltersResults,
    EpreuveResults,
    TheTitle,
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>